import { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

import config from '../../../config';
import { isNumeric, Issue } from '../../../constants';
import { useFetchPolicy } from '../../../App.hooks';
import { useIssueNotFound } from '../../../hooks/use-issue';

export function useGetCollection(id: string): GetCollectionResponse {
	const [issue, setIssue] = useState<Issue | null>();
	const fetchPolicy = useFetchPolicy(
		`collection:${id}:issue`,
		config?.app?.cache?.ttl?.getIssue,
	);

	const { loading, error, data } = useQuery<{ issue: Issue | null }>(
		GET_COLLECTION,
		{
			fetchPolicy,
			variables: { id, isSlug: !isNumeric(id) },
		},
	);

	useIssueNotFound(issue);

	useEffect(() => {
		if (loading) return;
		if (error) {
			console.error(error);
			return;
		}
		if (!data) return;

		const { issue } = data;
		setIssue(issue);
	}, [loading, error, data]);

	return {
		isLoading: loading,
		error: error ? new Error(error.message) : null,
		issue,
	};
}

interface GetCollectionResponse {
	isLoading: boolean;
	error: Error | null;
	issue?: Issue | null;
}

const GET_COLLECTION = gql`
	query GetCollection($id: ID!, $isSlug: Boolean!) {
		issue(id: $id, isSlug: $isSlug) {
			id
			name
			description
			cover
			slug
			releaseDate
			articles {
				id
				ArticleID
				thumbnail
				role
				name
				slug
				index
				description
				isFeatured
				created
			}
		}
	}
`;
